import { useState } from "react";
import styled from 'styled-components';

const content = {
  EN: [
      {
        heading: "Earn Money from Your Unused Spaces – Easily and Securely!",
        details: `Do you have an empty office room, workspace, or meeting room? Turn it into extra income with Room2w.com! Our platform allows you to rent out your unused spaces to individuals and businesses whenever you don’t need them. Set your own prices and availability – we’ll take care of the rest. Spaces can be booked quickly and easily via Room2w.com, and payments are handled securely through the platform. Join now and start earning from your unused spaces!`,
      },
      {
        heading: "Find the Perfect Workspace – Book Easily and Work in Peace!",
        details: `Working remotely but need a change from your home office? Traveling for work and looking for a quiet place to focus? Room2w.com offers a flexible solution: book an office room, workspace, or meeting room for a day, a week, or a month – exactly as you need. The price is always clear upfront, and you can book and pay directly through the platform. Say goodbye to noisy cafés and find your ideal workspace in just a few minutes!`,
      },
      {
        heading: "Need a Temporary Office or Workspace for a Few Months?",
        details: `Whether you're a growing company, a project team, or an entrepreneur in need of a temporary office during renovations, Room2w.com makes finding short-term rental spaces easy. Choose the right space for a few months without long-term commitments or complicated lease agreements. All spaces are available for booking directly on Room2w.com, with transparent pricing and secure payments through the platform. Simple, efficient, and hassle-free!`,
      }
  ],
  FI: [
    {
      heading: "Tienaa rahaa käyttämättömillä tiloillasi – helposti ja turvallisesti!",
      details: `Onko sinulla tyhjänä seisova toimistohuone, työtila tai neuvotteluhuone? Muuta se lisätuloksi Room2w.comin avulla! Palvelumme kautta voit helposti vuokrata käyttämättömiä tilojasi yksityishenkilöille ja yrityksille juuri silloin, kun itse et niitä tarvitse. Määritä itse hinnat ja saatavuus – me huolehdimme lopusta. Tilan voi varata nopeasti suoraan Room2w.comista, ja maksu hoituu helposti palvelun kautta. Liity nyt ja anna tilojesi tienata puolestasi!`,
    },
    {
      heading: "Löydä täydellinen työtila – varaa helposti ja työskentele rauhassa!",
      details: `Työskenteletkö etänä, mutta kaipaat vaihtelua kotitoimistoon? Oletko reissutyössä ja etsit rauhallista paikkaa keskittyä? Room2w.com tarjoaa joustavan ratkaisun: varaa itsellesi toimistohuone, työtila tai neuvotteluhuone päiväksi, viikoksi tai kuukaudeksi – juuri tarpeidesi mukaan. Hinta on aina ennalta tiedossa, ja voit varata ja maksaa tilan helposti suoraan palvelussa. Unohda meluisat kahvilat ja löydä itsellesi täydellinen työtila muutamassa minuutissa!`,
    },
    {
      heading: "Tarvitsetko väliaikaisen toimiston tai työtilan muutamaksi kuukaudeksi?",
      details: `Olitpa kasvava yritys, projektitiimi tai remontin ajaksi tilapäistä toimistoa etsivä yrittäjä, Room2w.com tekee lyhytaikaisen vuokratilan löytämisestä helppoa. Valitse sopiva tila muutamaksi kuukaudeksi ilman pitkiä sitoumuksia tai monimutkaisia sopimusneuvotteluja. Kaikki tilat ovat varattavissa suoraan Room2w.comista, hinta on aina selkeästi esillä, ja maksun voit hoitaa kätevästi palvelun kautta. Joustavaa, tehokasta ja vaivatonta!`,
    }
  ],
};

const Container = styled.div`
  display: flex;
  flex-direction: column;  /* Stack items vertically */
  align-items: center;  /* Center content horizontally */
  padding: 20px;
`;

const Content = styled.div`
  width: 60%;
  max-width: 1200px;
  background-color: #fff;
  padding: 0px;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
  margin-bottom: 20px; /* Adds space between heading and content */
`;

const Heading = styled(Content)`
  font-weight: bold;
`;

const HeadingBig = styled(Content)`
  font-weight: bold;
  font-size: 30px;
`;

const List = styled(Content)`
  margin-left: 25px;
`

const EarnWithUs = ({language}) => {

  return (
    <Container>

      {content[language].map((para, index) => (
        <Content key={index}>
          <HeadingBig>{para.heading}</HeadingBig>
          <p>{para.details}</p>
        </Content>
      ))}

    </Container>
  );
};

export default EarnWithUs;
